import React, { useState, useEffect } from 'react';
import QuizLayout from '../../../../shared/reusables/QuizLayout';
import MultipleChoiceCard from '../../../../shared/reusables/MultipleChoiceCard';
import QuizEndScreen from '../../../../shared/reusables/QuizEndScreen';
import { fetchWords } from '../../../../shared/api/darija';

const shuffleArray = (arr) => [...arr].sort(() => Math.random() - 0.5);

function buildOptions(allNouns, currentIndex, nounOrder) {
    const current = allNouns[nounOrder[currentIndex]];
    const correct = current.darija.toLowerCase();
    const distractors = shuffleArray(
        allNouns.filter((_, i) => i !== nounOrder[currentIndex])
    )
        .slice(0, 3)
        .map((n) => n.darija.toLowerCase());
    return shuffleArray([correct, ...distractors]);
}

export default function MultipleChoiceNouns({ onBack }) {
    const [allNouns, setAllNouns] = useState([]);
    const [nounOrder, setNounOrder] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [quizFinished, setQuizFinished] = useState(false);
    const [score, setScore] = useState(0);
    const [wrong, setWrong] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchWords('nouns')
            .then((nouns) => {
                const shuffled = shuffleArray(nouns.map((_, i) => i));
                setAllNouns(nouns);
                setNounOrder(shuffled);
            })
            .catch((err) => {
                console.error('[MultipleChoiceNouns]:', err);
                setError(err.message || 'Ophalen mislukt.');
            });
    }, []);

    useEffect(() => {
        if (!nounOrder.length || !allNouns.length || quizFinished) return;
        setOptions(buildOptions(allNouns, currentIndex, nounOrder));
        setSelected(null);
    }, [currentIndex, nounOrder, allNouns, quizFinished]);

    const handleAnswer = (option) => {
        const current = allNouns[nounOrder[currentIndex]];
        const isCorrect = option === current.darija.toLowerCase();
        setSelected(option);
        if (isCorrect) {
            setScore((s) => s + 1);
        } else {
            setWrong((w) => [...w, { question: current.dutch, answer: current.darija }]);
        }
        setTimeout(() => {
            if (currentIndex + 1 < nounOrder.length) setCurrentIndex((i) => i + 1);
            else setQuizFinished(true);
        }, 1200);
    };

    const resetQuiz = () => {
        const shuffled = shuffleArray(allNouns.map((_, i) => i));
        setNounOrder(shuffled);
        setCurrentIndex(0);
        setSelected(null);
        setQuizFinished(false);
        setScore(0);
        setWrong([]);
    };

    if (error) return null;
    if (!nounOrder.length || !allNouns.length) return null;

    if (quizFinished) {
        return (
            <QuizEndScreen
                correct={score}
                total={nounOrder.length}
                wrongItems={wrong}
                onRetry={resetQuiz}
            />
        );
    }

    const current = allNouns[nounOrder[currentIndex]];

    return (
        <QuizLayout
            current={currentIndex + 1}
            total={nounOrder.length}
            label="Zelfstandige naamwoorden"
            onBack={onBack}
        >
            <MultipleChoiceCard
                question={`Wat is ${current.dutch}?`}
                accentWord={current.dutch}
                options={options}
                selected={selected}
                correctAnswer={current.darija.toLowerCase()}
                onAnswer={handleAnswer}
                current={currentIndex + 1}
                total={nounOrder.length}
                label="Zelfstandige naamwoorden"
                questionIndex={currentIndex}
            />
        </QuizLayout>
    );
}
